/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import React, { useEffect, useState } from 'react';

import {
  ContentKeyboard,
  KeyboardKey,
  EmptyKey,
  KeyboardKeyDecoration,
  KeyboardKeyText,
  KeyboardKeyIcon,
} from './styled';

import { availableKeysSide1, availableKeysSide2 } from '../../services/mock';

interface KeyboardProps {
  value?: string;
  onChangeText?: (text: string) => void;
  onSearch?: (text: string) => void;
  clear?: () => void;
}

interface KeyItem {
  key?: string;
  action?: { mode?: number; title?: string };
  icon?: { icon: string; [k: string]: unknown };
  space?: boolean;
  search?: boolean;
  empty?: boolean;
}

export default function Keyboard({ value, onChangeText, onSearch, clear }: KeyboardProps) {
  const [isUpper, setIsUpper] = useState(false);
  const [mode, setMode] = useState(1);
  const [typedText, setTypedText] = useState(value ? value : '');

  const action = (item: KeyItem) => {
    if (item.key) {
      setTypedText(`${typedText}${isUpper ? item.key : item.key.toLowerCase()}`);
    }
    if (item.action) {
      handleAction(item);
    }
    if (item.icon) {
      handleIcon(item);
    }
    if (item.space) {
      setTypedText(`${typedText} `);
    }
    if (item.search) {
      safeHandleSearch();
    }
  };
  const backspace = () => {
    setTypedText(`${typedText}`.slice(0, -1));
  };

  const handleAction = (item: KeyItem) => {
    if (item.action.mode) {
      setMode(item.action.mode);
    }
    if (item.action.title === 'Limpar') {
      setTypedText('');
      clear();
    }
  };

  const handleIcon = (item: KeyItem) => {
    if (item.icon.icon === 'shift') {
      setIsUpper(!isUpper);
    }
    if (item.icon.icon === 'backspace') {
      backspace();
    }
  };

  const safeHandlePress = () => {
    if (onChangeText && typeof onChangeText === 'function') {
      onChangeText(typedText);
    }
  };

  const safeHandleSearch = () => {
    if (onSearch && typeof onSearch === 'function') {
      onSearch(typedText);
    }
  };

  useEffect(() => {
    safeHandlePress();
  }, [typedText]);

  return (
    <>
      <ContentKeyboard>
        {(mode === 1 ? availableKeysSide1 : availableKeysSide2).map((item: KeyItem, key: number) =>
          item.empty ? (
            <EmptyKey />
          ) : (
            <KeyboardKey
              key={key}
              action={item.action || item.icon}
              search={item.search}
              space={item.space}
              onPress={() => action(item)}
              onEnterPress={() => action(item)}
            >
              {item?.icon?.icon === 'shift' && isUpper ? <KeyboardKeyDecoration /> : null}
              {item.key ? <KeyboardKeyText isUpper={isUpper}>{item.key}</KeyboardKeyText> : null}
              {item.action ? <KeyboardKeyText small>{item.action.title}</KeyboardKeyText> : null}
              {item.search ? <KeyboardKeyText small>Pesquisar</KeyboardKeyText> : null}
              {item.icon ? <KeyboardKeyIcon {...item.icon} /> : null}
            </KeyboardKey>
          ),
        )}
      </ContentKeyboard>
    </>
  );
}
